import type { IContactUsModalProps } from "app/components/React/ContactUs/ContactUsModal";
import { ContactUsModal } from "app/components/React/ContactUs/ContactUsModal";
import type * as React from "react";
import { connect } from "react-redux";
import LocationService from "pro-features/components/Modals/src/UnlockModal/LocationService";
import { closeContactUsModal } from "../../../actions/contactUsModalActions";

const ContactUsModalContainer: React.FunctionComponent<IContactUsModalProps> = (props) => {
    return <ContactUsModal {...props} />;
};

ContactUsModalContainer.displayName = "ContactUsModalContainer";

const mapStateToProps = ({ contactUsModal }) => {
    const { isOpen, label } = contactUsModal;
    const location = `${LocationService.getCurrentLocationTracking()}/${label}`;

    return {
        isOpen,
        location,
        label,
    };
};

function mapDispatchToProps(dispatch) {
    return {
        onClose: () => {
            dispatch(closeContactUsModal());
        },
    };
}
export default connect(mapStateToProps, mapDispatchToProps)(ContactUsModalContainer);
